export default {
  data() {
    return {
      exportOrderExcelFields: [
        {
          label: "Accession ID",
          value: "accession_id",
        },
        {
          label: "Bill To",
          value: "billing_type",
        },
        // {
        //   label: "Case Type",
        //   value: "case_types",
        // },
        {
          label: "Territory Manager",
          value: "hospital_marketers",
        },
        {
          label: "Insurance Name",
          value: "billing_info.payor",
        },
        {
          label: "Order ID",
          value: "order_id",
        },
        {
          label: "Ordering Facility",
          value: "hospital.name",
        },
        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },
        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },
        {
          label: "Policy No",
          value: "billing_info.policy_id",
        },
        {
          label: "Rejection Reason",
          value: "reasons",
        },
        {
          label: "Status",
          value: "status",
        },
        {
          label: "Order Codes",
          value: "test_panel_id",
        },
        {
          label: "ICD Codes",
          value: "icd_codes",
        },

        // {
        //   label: "Ordering Facility Phone",
        //   value: "hospital.phone",
        // },
        {
          label: "Patient Middle Name",
          value: "patient_info.middle_name",
        },
        {
          label: "Patient Gender",
          value: "patient_info.gender",
        },
        {
          label: "Patient Phone",
          value: "patient_info.phone",
        },
        {
          label: "Patient Email",
          value: "patient_info.email",
        },
        {
          label: "Patient Address",
          value: "patient_info.address",
        },
      ],
      defaultExportOrderExcelFields: [
        {
          label: "Order ID",
          value: "order_id",
        },
        {
          label: "Accession ID",
          value: "accession_id",
        },
        {
          label: "Case Type",
          value: "case_types",
        },
        {
          label: "Bill To",
          value: "billing_type",
        },
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },
        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },
        {
          label: "Ordering Facility",
          value: "hospital.name",
        },
        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Insurance Name",
          value: "billing_info.payor",
        },
        {
          label: "Policy No",
          value: "billing_info.policy_id",
        },
        {
          label: "Status",
          value: "status",
        },
        {
          label: "Test Panels",
          value: "test_panel_id",
        },
        {
          label: "Territory Manager",
          value: "hospital_marketers",
        },
      ],
    }
  },
}
